module.exports = __webpack_public_path__ + "media/store/fonts/UCityProVar-611dd91f8d8f75cc8461a31e08722556.woff2";